import styled from "styled-components"

const FilesSize = styled.span`
  font-size: ${props => props.theme.font.size.inputlabel};
  position: relative;
  top: -3px;
`

export default FilesSize
